<template>
	<div class="layout-inner dashbaord learner_profile">
		<navbar></navbar>
		<div class="layout-container">
			<div class="layout-content learner-profile-page">
				<section class="profile-card" :aria-label="$t('personalInfo')">
					<div class="profile-card__avatar" aria-hidden="true">
						<span class="ic ic-user"></span>
					</div>
					<div class="profile-card__info">
						<div class="profile-card__name">{{ userName }}</div>
						<div class="profile-card__email">{{ email }}</div>
					</div>
					<button
						type="button"
						class="profile-card__edit"
						:aria-label="$t('changePassword')"
						@click="showChangePasswordModal">
						<span class="ic ic-edit"></span>
					</button>
				</section>

				<learner-profile-resume ref="learnerProfileResume" v-if="isResumeUploadEnabled"></learner-profile-resume>

				<section class="profile-section-card program-interest-section" :aria-label="$t('programAndCareerInterest')">
					<div class="profile-section-card__head">
						<h2 class="profile-section-card__title">{{ $t('programAndCareerInterest') }}</h2>
						<button type="button" class="profile-section-card__action" @click="editProfileClicked">
							{{ $t('update') }}
						</button>
					</div>

					<div class="profile-section-card__body">
						<div class="interest-field-card" v-for="(question, i) in questions" :key="question.id || i">
							<div class="interest-field-card__header">
								<span class="interest-field-card__icon ic" :class="'ic-' + question.icon" aria-hidden="true"></span>
								<span class="interest-field-card__label">{{ question.shortTitle }}</span>
							</div>

							<div class="interest-field-card__value">
								<template v-if="question.type === 'SELECT'">
									<template v-if="question.optionType === 'DYNAMIC'">
										<div v-if="question.response" :title="question.response">
											{{ question.response }}
										</div>
										<div class="no_info" v-else>{{ $t('na') }}</div>
									</template>
									<template v-if="question.optionType === 'STATIC'">
										<div class="selected_entity" v-if="question.response">
											<span :title="question.response">{{ question.response }}</span>
										</div>
										<div class="no_info" v-else>{{ $t('na') }}</div>
									</template>
									<template v-if="question.optionType === 'STATIC-MULTI'">
										<div v-if="question.selectedResponses && question.selectedResponses.length > 0">
											<div class="selected_entity" v-for="(sR, idx) in question.selectedResponses" :key="idx">
												<span :title="sR">{{ sR }}</span>
											</div>
										</div>
										<div class="no_info" v-else>{{ $t('na') }}</div>
									</template>
									<template v-if="question.optionType === 'DYNAMIC-MULTI'">
										<div v-if="question.selectedResponses && question.selectedResponses.length > 0">
											<div class="selected_entity" v-for="(sR, idx) in question.selectedResponses" :key="idx">
												<span :title="sR">{{ sR }}</span>
											</div>
										</div>
										<div class="no_info" v-else>{{ $t('na') }}</div>
									</template>
								</template>
								<template v-else-if="question.type === 'MULTI_LINE_TEXT'">
									<textarea
										:rows="question.lineCount"
										cols="35"
										:maxlength="question.responseLimit"
										v-model.trim="question.response"
										:disabled="true"></textarea>
								</template>
							</div>
						</div>
					</div>
				</section>

				<learner-profile-question ref="learnerProfileQuestion"></learner-profile-question>

				<b-modal class="h-100 d-inline-block" ref="changePasswordModal" size="xl" :header-bg-variant="'light'" hide-footer no-close-on-backdrop no-close-on-esc>
					<div slot="modal-header" class="header-section w-100">
						<div class="popup_head_txt float-left">
							<label class="head_txt module_type_name">
								{{ $t('changePassword') }}
							</label>
						</div>
						<div class="float-right">
							<button class="btn_close" aria-label="close" @click="cancelChangePasswordModal">
								<span class="ic-close"></span>
							</button>
						</div>
					</div>
					<div class="modal_content">
						<div class="page-content-section row">
							<b-container fluid>
								<b-row>
									<b-col cols="12" class="form-field-section">
										<b-card>
											<div class="row field-row">
												<div class="col-12 title-column mb-1" style="background: #f5f5f5;">
													<label id="password">
														{{ $t('oldPassword') }}
													</label>
												</div>
												<div class="col-12 field-column">
													<input
														v-model="oldpassword"
														:aria-label="$t('password')"
														:placeholder="$t('enterOldPassword')"
														required
														type="password"
														style="width: 100%;" />
												</div>
											</div>

											<div class="row field-row message_bar mt-1">
												<div class="col-12 field-column">
													<p>A strong password contains a mix of numbers, letters, and symbols. It is hard to guess, does not resemble a real word, and is only used for this account.</p>
												</div>
											</div>

											<div class="row field-row mt-1">
												<div class="col-12 title-column mb-1" style="background: #f5f5f5;">
													<label id="newPassword">
														{{ $t('newPassword') }}
													</label>
												</div>
												<div class="col-12 field-column">
													<input
														v-model="newpassword"
														:aria-label="$t('newPassword')"
														:placeholder="$t('enterNewPassword')"
														required
														type="password"
														style="width: 100%;" />
												</div>
											</div>

											<div class="row field-row mt-1">
												<div class="col-12 title-column mb-1" style="background: #f5f5f5;">
													<label id="reEnterPassword">
														{{ $t('reEnterNewPassword') }}
													</label>
												</div>
												<div class="col-12 field-column">
													<input
														v-model="newpassword2"
														:aria-label="$t('reEnterPassword')"
														:placeholder="$t('reEnterNewPassword')"
														required
														type="password"
														style="width: 100%;" />
												</div>
											</div>

											<div class="btn-container mt-2 text-center">
												<button v-on:click="validatePassword" class="btn btn-primary" size="sm" :disabled="buttonDisabled">
													{{ $t('changePassword') }}
												</button>
											</div>
										</b-card>
									</b-col>
								</b-row>
							</b-container>
						</div>
					</div>
				</b-modal>
			</div>
		</div>
	</div>
</template>

<script>
	import _ from 'lodash'
	import { mapState, mapActions } from 'vuex'
	import Navbar from '../../misc/components/./Navbar'
	import { PACKAGE } from '../../../package_constants'
	import LearnerProfileResume from './LearnerProfileResume'
	import LearnerProfileQuestion from './LearnerProfileQuestion'

	export default {
		name: 'learner-profile',
		components: {
			Navbar,
			LearnerProfileResume,
			LearnerProfileQuestion
    },
		data: () => {
			return {
				questions: [],
				oldpassword: '',
	      newpassword: '',
	      newpassword2: ''
			}
		},
		computed: {
			...mapState({
    		'userObject': state => state.login.userObj,
    		'enabledFeatures': state => state.dashboard.enabledFeatures
	    }),
			uuid () {
				return this.userObject.uuid
			},
    	email () {
        return this.userObject.eMail
      },
      firstName () {
        return this.userObject.firstName
      },
      lastName () {
        return this.userObject.lastName
      },
			userName () {
        return this.firstName + ' ' + this.lastName
      },
	    buttonDisabled () {
	      return !(this.oldpassword && this.newpassword && this.newpassword2)
	    },
	    isResumeUploadEnabled () {
      	let profileFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROFILE_FEATURE_ID]
        if (profileFeature && profileFeature.enabled) {
          let flags = profileFeature.flags
          let found = _.find(flags, (flag) => {
          	return (flag.title === 'learnerCanUploadResume')
          })
          return found ? found.enabled : false
        }
        return false
      }
		},
		created () {
			this.$root.$on('reloadLearnerDashboard', () => {
	      this.populateProfileQuestionData()
	    })
		},
		mounted () {
			this.populateProfileQuestionData()
    },
		methods: {
			...mapActions([
				'loadMajorMinor',
        'loadCareerByCode',
        'loadUpdatePassword',
        'loadQuestionsForGroup'
	    ]),
	    populateProfileQuestionData () {
	    	this.questions = []
        this.loadQuestionsForGroup('PROFILE_POPUP_1').then(questions => {
	        _.forEach(questions, (question, index) => {
	        	let response = (question.responses && question.responses.length > 0) ? question.responses[0] : null
	        	if ((question.type === 'SELECT') || (question.type === 'MULTI_LINE_TEXT')) {
            	if ((question.optionSource === 'CAREER') || (question.optionSource === 'PROGRAM')) {
            		question.response = ''
            	} else {
            		question.response = response
            	}
            }
            if (question.optionType === 'STATIC') {
            		if(question.response ==='Other'){
                    question.response = question.responses[1]
                }
            }
            if (question.optionType === 'DYNAMIC') {
              if (question.optionSource === 'CAREER') {
              	this.loadCareerByCode(response).then(career => {
              		question.response = career.name
              	})
              } else if (question.optionSource === 'PROGRAM') {
              	this.loadMajorMinor({code: response}).then(program => {
              		question.response = program.name
              	})
              }
            }
            if (question.optionType === 'DYNAMIC-MULTI') {
              if (question.optionSource === 'CAREER') {
                question.selectedResponses = []
                if (question.responses) {
                  question.responses.forEach((item, i) => {
                    this.loadCareerByCode(item).then(career => {
                  		question.selectedResponses.push(career.name)
                  	})
                  })
                }
              } else if (question.optionSource === 'PROGRAM') {
                question.selectedResponses = []
                if (question.responses) {
                  question.responses.forEach((item, i) => {
                    this.loadMajorMinor({code: item}).then(program => {
                  		question.selectedResponses.push(program.name)
                  	})
                  })
                }
              }
            }
            if (question.optionType === 'STATIC-MULTI') {
                question.selectedResponses = []
                if(question.responses) {
	                question.responses.forEach((item, i) => {
	                		question.selectedResponses.push(item)
	                })
                }
            }

            this.questions.push(question)
        	})
        	setTimeout(() => {

        	}, 1000)
	      })
      },
      editProfileClicked () {
				this.$refs.learnerProfileQuestion.showAddProgCarIntModal()
			},
			showChangePasswordModal () {
				this.reset()
				this.$refs.changePasswordModal.show()
			},
			cancelChangePasswordModal () {
				this.$refs.changePasswordModal.hide()
			},
			validatePassword () {
	      if (this.newpassword !== this.newpassword2) {
	        this.$notify({
	          group: 'notify',
	          type: 'error',
	          title: '',
	          text: 'Passwords do not match'
	        })
	      } else if (this.newpassword.length < 6) {
	        this.$notify({
	          group: 'notify',
	          type: 'error',
	          title: '',
	          text: 'Password cannot be less than 6 characters'
	        })
	      } else {
	        this.changePassword()
	      }
	    },
	    changePassword () {
	      this.changePassword.userUuid = this.uuid
	      this.changePassword.firstName = this.firstName
	      this.changePassword.lastName = this.lastName
	      var formData = new FormData()
	      formData.append('oldPassword', this.oldpassword)
	      formData.append('newPassword', this.newpassword)
	      formData.append('userUuid', this.uuid)
	      formData.append('firstName', this.firstName)
	      formData.append('lastName', this.lastName)
	      this.loadUpdatePassword({data: formData}).then(res => {
	        if (res.status === 200) {
	          this.$notify({
	            group: 'notify',
	            type: 'success',
	            title: '',
	            text: 'Passwords successfully updated!'
	          })
	          this.reset()
	          setTimeout(() => {
	            this.cancelChangePasswordModal()
	          }, 0)
	        } else {
	          this.$notify({
	            group: 'notify',
	            type: 'error',
	            title: '',
	            text: 'Please enter correct password!'
	          })
	          this.reset()
	        }
	      })
	    },
	    reset () {
	      this.oldpassword = ''
	      this.newpassword = ''
	      this.newpassword2 = ''
	    }
	  }
	}
</script>

<style lang="scss" scoped>
$profile-green: var(--TU__BtnClrPri, #009f51);
$profile-page-bg: #f5f5f5;
$profile-card-bg: #fff;
$profile-text: #303030;
$profile-text-muted: #6e6e6e;
$profile-border: #e5e5e5;
$profile-avatar-blue: #58abfe;
$profile-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
$profile-radius: 10px;
$profile-touch-min: 44px;

.learner_profile.layout-inner {
	overflow-x: hidden;
	overflow-y: auto;
	min-height: 85vh;
}

.learner-profile-page {
	background: $profile-page-bg;
	padding: 12px 12px 24px;
	min-height: 100%;
}

.profile-card {
	display: flex;
	align-items: center;
	gap: 12px;
	background: $profile-card-bg;
	border-radius: $profile-radius;
	box-shadow: $profile-shadow;
	padding: 14px 16px;
	margin-bottom: 16px;
	min-height: 72px;
	box-sizing: border-box;
}

.profile-card__avatar {
	flex-shrink: 0;
	width: 56px;
	height: 56px;
	border-radius: 50%;
	background: $profile-avatar-blue;
	display: flex;
	align-items: center;
	justify-content: center;

	.ic-user {
		font-size: 28px;
		color: #fff;
	}
}

.profile-card__info {
	flex: 1;
	min-width: 0;
	overflow: hidden;
}

.profile-card__name {
	font-size: 1.05rem;
	font-weight: 600;
	color: $profile-text;
	line-height: 1.3;
	word-break: break-word;
}

.profile-card__email {
	margin-top: 4px;
	font-size: 0.875rem;
	color: $profile-text-muted;
	line-height: 1.35;
	word-break: break-word;
}

.profile-card__edit {
	flex-shrink: 0;
	width: 36px;
	height: 36px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;
	border: none;
	background: transparent;
	cursor: pointer;

	.ic-edit {
		font-size: 1.15rem;
		color: $profile-green;
	}
}

.profile-section-card {
	background: $profile-card-bg;
	border-radius: $profile-radius;
	box-shadow: $profile-shadow;
	margin-bottom: 16px;
	overflow: visible;
}

.profile-section-card__head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 14px 16px;
	border-bottom: 1px solid $profile-border;
}

.profile-section-card__title {
	margin: 0;
	font-size: 1rem;
	font-weight: 600;
	color: $profile-text;
	line-height: 1.3;
	flex: 1;
	min-width: 0;
}

.profile-section-card__action {
	flex-shrink: 0;
	min-height: $profile-touch-min;
	padding: 8px 4px;
	border: none;
	background: transparent;
	font-size: 0.9rem;
	font-weight: 600;
	color: $profile-green;
	text-transform: lowercase;
	cursor: pointer;
}

.profile-section-card__body {
	padding: 12px 16px 16px;
}

.interest-field-card {
	margin-bottom: 16px;

	&:last-child {
		margin-bottom: 0;
	}
}

.interest-field-card__header {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 8px;
}

.interest-field-card__icon {
	flex-shrink: 0;
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid $profile-border;
	border-radius: 6px;
	box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
	font-size: 1.35rem;
	color: #d2d2d2;
}

.interest-field-card__label {
	font-size: 0.9rem;
	font-weight: 600;
	color: $profile-text;
	line-height: 1.3;
}

.interest-field-card__value {
	border: 1px solid $profile-border;
	border-radius: 6px;
	padding: 10px 12px;
	font-size: 0.9rem;
	color: $profile-text;
	line-height: 1.4;
	word-break: break-word;

	.no_info {
		color: #c8c8c8;
	}

	textarea {
		border: none !important;
		width: 100%;
		max-width: 100%;
		padding: 0;
		resize: none;
		background: transparent;
		color: $profile-text;
	}
}

.selected_entity {
	margin-bottom: 6px;

	&:last-child {
		margin-bottom: 0;
	}
}

.popup_head_txt {
	font-size: 1.1rem;
	font-weight: 600;
}

@media (min-width: 481px) {
	.learner-profile-page {
		padding: 16px 20px 28px;
	}

	.profile-card__name {
		font-size: 1.15rem;
	}
}
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerProfile.vue